import './FooterMidden.scss'

function FooterMidden () {
  return (
    <div className='footer_midden'>
      <div className='div_midden'>
        <img src='/iconpay.png' alt='' />
      </div>
    </div>
  )
}

export default FooterMidden
